import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import Colors from "../../../../global/Colors";
import { useQueryParams } from "../../../../../hooks/useQueryParams";

export default function StatusSelect({ defaultSelection, optionsList }) {
  const { updateFilter } = useQueryParams();
  const [selected, setSelected] = useState(
   defaultSelection
  );

  const handleSubmit = (selection) => {
    setSelected(selection);
    updateFilter("status", selection);
  };

  return (
    <div className="">
      <Tooltip title={``} placement="right">
        <FormControl
          className="mx-auto block text-sm border-none"
          fullWidth
          size="small"
        >
          <Select
            className="w-full text-sm border-none"
            labelId="document-status"
            id="action-items-status-select"
            value={selected}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(e) => handleSubmit(e.target.value)}
            sx={{
              color: Colors.white,
              backgroundColor: "#4C2AC6",
              boxShadow: "none",
              border: "1px solid #4C2AC6",
              borderRadius: "35px",
             
              "& .MuiSvgIcon-root": {
                color: Colors.white,
              },
              
            }}
            inputProps={{
              MenuProps: {
                autoFocus: false,
                MenuListProps: {
                  
                  sx: {
                    color: Colors.gray[800],
                    backgroundColor: Colors.white,
                  },
                },
              },
            }}
          >
            {!optionsList ? (
              <MenuItem>No results</MenuItem>
            ) : (
              optionsList.map((type) => (
                <MenuItem value={type.value} key={type.value}>
                  {type.label}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
}
